import styled from 'styled-components';

export const ResponseCommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
  margin-top: 0.5rem;
`;
